import { PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { loginSelector } from "../store/features/loginSlice";
import Loader from "../common/ui/Loader";
import { PUBLIC_SKIP_DASHBOARD_REDIRECT } from "@/utils/constant/login.constant";

export default function PublicRouteGuard({ children }: PropsWithChildren) {
  const { currentUser } = useSelector(loginSelector);
  const location = useLocation();

  if (currentUser === undefined) {
    return <Loader />;
  }
  // Redirect to dashboard if user is authenticated and path is not in exception list
  const isResetPasswordWithToken = location.pathname === "/reset-password" && location.search.includes("?token=");
  const shouldSkipRedirect = (PUBLIC_SKIP_DASHBOARD_REDIRECT.includes(location.pathname) && isResetPasswordWithToken) || location.pathname.includes("/share/");
  // console.log({ isResetPasswordWithToken, shouldSkipRedirect, T: PUBLIC_SKIP_DASHBOARD_REDIRECT.includes(location.pathname), P: location.pathname });

  if (currentUser && !shouldSkipRedirect) {
    const path = (currentUser?.userType === "ORG" && currentUser?.role === "User") || Boolean(currentUser?.isCloneUserRole) ? "/home/profile" : "/dashboard";
    return <Navigate to={path} replace />;
  }
  return children;
}
